// Constants
import { GIL_OTP_ERROR_CODE, GIL_RISK_ERROR_CODE } from './constants/resolver.utils.constants';

const isGilRiskError = (code: string): boolean => code === GIL_RISK_ERROR_CODE;

const isGilOtpError = (code: string): boolean => code === GIL_OTP_ERROR_CODE;

export { isGilRiskError, isGilOtpError };
